import React, { useEffect } from "react";
import { useLocation } from "@reach/router";
import SEO from "../components/head";
import Layout from "../components/layout";
import Main from "../components/main";
import { trackPageview } from "../services";
import { mergeWithInitialQuery } from "../utils";
import { EventProvider } from '../context/EventProvider';
import { StrapiSourceData } from "../interfaces/strapi";

const Homepage = ({ pageContext }: { pageContext: StrapiSourceData }) => {
  const location = useLocation();

  useEffect(() => {
    const query = mergeWithInitialQuery(location.search);
    trackPageview(`${location.pathname}?${query}`);
  }, []);

  return (
    <EventProvider data={pageContext} >
      <Layout className="page__home">
        <Main />
      </Layout>
    </EventProvider>
  );
};

export default Homepage;

export const Head = ({ pageContext }: { pageContext: StrapiSourceData }) => {
  return (<EventProvider data={pageContext} ><SEO /></EventProvider>);
};



